export enum BranchStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum BranchServiceStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

import { BranchType } from "@ibada/shared-types/common"

export { BranchType }

export type BranchService = {
  id: string
  name: string
  status: BranchServiceStatus
  source?: string
  createdAt?: string
}

/** One of the few member faces the branches list sends per branch (empty without members access). */
export type BranchMemberPreview = {
  id: string
  name: string
  avatarUrl: string | null
}

export type Branch = {
  id: string
  name: string
  code?: string | null
  slug?: string
  details?: string
  phoneNumber?: string
  branchType: BranchType
  services: BranchService[]
  principalMemberId?: string | null
  principalMember?: {
    id: string
    name: string
    email?: string | null
  } | null
  language?: string
  timezone?: string
  customFieldValues?: Record<string, unknown>
  status: BranchStatus
  source?: string
  /** List only: people on the branch roll, users with access to it (its team), and up to five faces. */
  membersCount?: number
  teamCount?: number
  memberPreview?: BranchMemberPreview[]
  createdAt: string
  updatedAt: string
}

export type CreateBranchInput = {
  name: string
  code?: string
  branchType?: BranchType
  details?: string
  phoneNumber?: string
  principalMemberId?: string | null
  language?: string
  timezone?: string
  status?: BranchStatus
  /** Opt in to administering the branch being created. Omitted or false means no access is granted. */
  grantCreatorAccess?: boolean
  customFieldValues?: Record<string, unknown>
}

export type UpdateBranchInput = {
  name?: string
  branchType?: BranchType
  details?: string
  phoneNumber?: string
  principalMemberId?: string | null
  language?: string
  timezone?: string
  status?: BranchStatus
  customFieldValues?: Record<string, unknown>
}
